import Bluebird from 'bluebird';

import { ReportFileMetadataUsageEnum, ReportFileTypeEnum, uploadReportAttachment } from './reportAttachmentSignedUrl';

const uploadReportSignature = (
  signaturePath: string,
  siteKey: string,
  reportKey: string,
  cancelHandler: () => any
): Promise<string> => {
  return new Bluebird((resolve: (T: any) => void, reject: (E: Error) => void, onCancel: (A?: any) => void) => {
    if (onCancel) {
      onCancel(cancelHandler);
    }

    // Generate a unique filename for the signature (data URL has no meaningful filename)
    const fileName = `signature-${Date.now()}.png`;

    uploadReportAttachment({
      body: {
        fileName,
        fileType: ReportFileTypeEnum.IMAGE,
        mimeType: 'image/png',
        reportID: reportKey,
        siteID: siteKey,
        usageType: ReportFileMetadataUsageEnum.SIGNATURES,
        questionIndex: -1,
        childQuestionIndex: ''
      },
      file: signaturePath
    })
      .then(filePath => resolve(filePath))
      .catch(err => reject(err as Error));
  });
};

export default uploadReportSignature;
